import MuiTableHead, { TableHeadProps as MuiTableHeadProps } from '@material-ui/core/TableHead';

export type DSTableHeadProps = MuiTableHeadProps;

export const DSTableHead = MuiTableHead;
